import React, { createContext, useState, useContext, useMemo } from "react";
import PropTypes from "prop-types";
import { ThemeProvider as MUIThemeProvider } from "@material-ui/core/styles";
import { CssBaseline } from "@material-ui/core";
import { ptBR } from "@material-ui/core/locale";

import buildTheme from "../../theme";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
	const [darkMode, setDarkMode] = useState(
		() => localStorage.getItem("preferredTheme") === "dark"
	);

	const toggleTheme = () => {
		setDarkMode((prevMode) => {
			localStorage.setItem("preferredTheme", prevMode ? "light" : "dark");
			return !prevMode;
		});
	};

	const theme = useMemo(
		() => buildTheme(darkMode ? "dark" : "light", ptBR),
		[darkMode]
	);

	const contextValue = useMemo(() => ({ darkMode, toggleTheme }), [darkMode]);

	return (
		<ThemeContext.Provider value={contextValue}>
			<MUIThemeProvider theme={theme}>
				<CssBaseline />
				{children}
			</MUIThemeProvider>
		</ThemeContext.Provider>
	);
};
ThemeProvider.propTypes = {
	children: PropTypes.node.isRequired,
};

export const useThemeContext = () => useContext(ThemeContext);
